import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';

import Logo from '@/assets/ic_gdt-white.svg';
import { FADE_IN_OUT } from '@/utils';

export const Loader = ({ isVisible = false, timeout = false }) => {
  const [isShowState, setIsShow] = useState(false);
  const timeDelay = timeout ? 1500 : 300;

  useEffect(() => {
    const timeoutIn = setTimeout(() => setIsShow(isVisible), timeDelay);
    return () => {
      setIsShow(false);
      clearTimeout(timeoutIn);
    };
  }, [isVisible, timeDelay, timeout]);

  return (
    <AnimatePresence>
      {isShowState && (
        <motion.div
          animate="show"
          className="loaderGdt show"
          initial="hide"
          variants={FADE_IN_OUT}
        >
          <div className="max-w-[250px] w-full">
            <img
              alt="Logo Gran DT en loader"
              className="w-14 h-auto mx-auto"
              src={Logo}
            />
            <div className="h-[15px] bg-gdt-gray-2 rounded-lg overflow-hidden mt-5">
              <motion.div
                animate={{ x: '100%' }}
                initial={{ x: '-100%' }}
                transition={{
                  ease: 'easeInOut',
                  duration: 1.2,
                  repeat: Infinity,
                }}
              >
                <div className="h-[15px] bg-gdt-blue rounded-lg w-[150px]" />
              </motion.div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
